import { alpha } from '@mui/system';
import { themeObject } from '../../lib';

export const appVersionModalStyles = {
    root: {
        '& .MuiDialog-container': {
            '& .MuiPaper-root': {
                overflow: 'hidden',
                height: '320px',
                width: '333px',
                borderRadius: '10px',
                boxShadow: `
                0px 6px 30px 5px ${alpha(themeObject.palette.grayScale[700], 0.12)},
                0px 16px 24px 2px ${alpha(themeObject.palette.grayScale[700], 0.14)},
                0px 8px 10px -5px ${alpha(themeObject.palette.grayScale[700], 0.2)},
                `,
            },
        },
    },
    dialogContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
    logoContainer: {
        mt: 2.5,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    dialogBodyContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        overflowY: 'hidden',
    },
    dialogVersionContainer: {
        mt: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    dialogIcon: {
        width: '232.66px',
        height: '45px',
    },
    aboutLabel: {
        fontFamily: 'Raleway',
        fontSize: '20px',
        fontWeight: 500,
        lineHeight: '23.48px',
        color: themeObject.palette.primary[700],
        fontVariantNumeric: 'lining-nums',
    },
    infoLabel: {
        fontFamily: 'Red Hat Text',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '18.52px',
        color: themeObject.palette.grayScale[800],
    },
    closeButton: {
        my: 2,
    },
};
